export const paymentModeDisplayNameToEnumMap = {
  'TO PAY': 'TO_PAY',
  PAID: 'PAID'
};

export const paymentStatusRespEnum = {
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  INITIATED: 'INITIATED',
  EXPIRED: 'EXPIRED'
};
